import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "../../form/input";
import PhoneIcon from "../../../assets/icons/call.svg";
import LoadingButton from "../../common/loadingButton";
import { convertPersianDigitsToEnglish } from "../../../utils/Functions";

const schema = yup.object().shape({
  phoneNumber: yup
    .string()
    .required("شماره موبایل الزامی است.")
    .transform((value) => convertPersianDigitsToEnglish(value))
    .matches(/^09\d{9}$/, "فرمت شماره موبایل معتبر نیست."),
});

const PhoneNumber = ({
  checkMobileHandler,
  mobileCheckLoading,
}: {
  checkMobileHandler: any;
  mobileCheckLoading: any;
}) => {
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    ...form
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const onSubmit = (data: any) => {
    const formattedData = {
      ...data,
      phoneNumber: convertPersianDigitsToEnglish(data.phoneNumber),
    };
    checkMobileHandler(formattedData.phoneNumber);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="flex-1 w-full h-full mt-10 flex flex-col justify-between"
    >
      <Input
        form={form}
        errors={errors}
        title="شماره همراه"
        icon={<img src={PhoneIcon} alt="شماره همراه" />}
        placeholder="09121111111"
        id="phoneNumber"
        type="text"
        direction="ltr"
        style={{ direction: "ltr", letterSpacing: ".3rem" }}
      />
      <div>
        <LoadingButton
          title="ورود"
          type="submit"
          loading={mobileCheckLoading}
          disabled={!isValid || !isDirty || mobileCheckLoading}
        />
        <div className="flex justify-between items-center mt-2 text-pr_primary">
          <a
            href="/privacy"
            target="_blank"
            className="text-xs text-pr_primary"
          >
            حریم خصوصی
          </a>
          {" | "}
          <a href="/terms" target="_blank" className="text-xs text-pr_primary">
            شرایط استفاده
          </a>
          {" | "}
          <a
            href="/rules-and-regulations"
            target="_blank"
            className="text-xs text-pr_primary"
          >
            قوانین و مقررات
          </a>
        </div>
      </div>
    </form>
  );
};

export default PhoneNumber;
